import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: `'Proxima Nova', 'Arial', sans-serif`,
    fontWeightRegular: 400,
    fontWeightBold: 700,
  },
});

export default theme;
